import { AUTHORIZATION_UPDATE_ANDROID_VERSION_CODE, REACT_NATIVE_STATUS } from 'constants/index'

export const resolveGeoAccess = (geoData, supportedCountryMap) => {
  if (!geoData) {
    return {
      userGeoInfo: {
        ip: '',
        country: null,
      },
      blockedCountryCode: null,
    }
  }

  if (
    geoData.country_code2 &&
    !Object.prototype.hasOwnProperty.call(supportedCountryMap, geoData.country_code2)
  ) {
    return {
      userGeoInfo: null,
      blockedCountryCode: geoData.country_code2,
    }
  }

  return {
    userGeoInfo: {
      ip: geoData.ip,
      country: geoData.country_code2,
    },
    blockedCountryCode: null,
  }
}

export const resolveNativeAuthorizationAction = ({
  isBanned,
  userGeoInfo,
  referralId,
  versionCode,
}) => {
  if (isBanned) {
    return {
      redirectTo: '/blocked',
      message: null,
    }
  }

  if (!userGeoInfo) {
    return {
      redirectTo: null,
      message: null,
    }
  }

  if (Number(versionCode) >= AUTHORIZATION_UPDATE_ANDROID_VERSION_CODE) {
    return {
      redirectTo: null,
      message: {
        status: REACT_NATIVE_STATUS.LOGIN,
        geoData: userGeoInfo,
        referralId,
      },
    }
  }

  return {
    redirectTo: null,
    message: {
      status: REACT_NATIVE_STATUS.SIGNUP,
      userGeoInfo,
      referralId,
    },
  }
}
